import { createDefaultSearchStore } from '../store/store';
import { SubstrateSearchSuggestionSegment } from 'owa-search-service';
import { trace } from 'owa-trace';

// Gets the display text to be put in the search box for the given segment.
export default function getSegmentSearchBoxText(segment: SubstrateSearchSuggestionSegment): string {
    const defaultSearchStore = createDefaultSearchStore();

    // This function shouldn't be called without a segment.
    if (!segment) {
        trace.error('getSegmentSearchBoxText: Called without a segment');
        return defaultSearchStore.searchText;
    }

    // Return display text based on the segment type.
    switch (segment.Type) {
        case 'Person':
            return defaultSearchStore.searchText;
        case 'Text':
            return segment.Text;
        default:
            trace.error('getSegmentSearchBoxText: Unknown segment type');
            return defaultSearchStore.searchText;
    }
}
